import ControlKind from '../Shared/controlKind';
import dateConfig from './Date';
import numericConfig from './Numeric';
import pageConfig from './Page';
import readOnlyTextConfig from './ReadOnlyText';
import signatureConfig from './Signature';
import textConfig from './Text';
import selectConfig from './Select';
import imageConfig from './Image';
import formulaConfig from './CalculatedValue';
import attachmentConfig from './Attachment';
import timeConfig from './Time';
import { ControlConfig } from './controlConfig';

const config: Record<ControlKind, ControlConfig> = {
  [ControlKind.PAGE]: pageConfig,
  [ControlKind.DATE]: dateConfig,
  [ControlKind.TEXT]: textConfig,
  [ControlKind.READONLY_TEXT]: readOnlyTextConfig,
  [ControlKind.SIGNATURE]: signatureConfig,
  [ControlKind.NUMERIC]: numericConfig,
  [ControlKind.SELECT]: selectConfig,
  [ControlKind.IMAGE]: imageConfig,
  [ControlKind.CALCULATED_VALUE]: formulaConfig,
  [ControlKind.ATTACHMENT]: attachmentConfig,
  [ControlKind.TIME]: timeConfig,
  [ControlKind.NOT_DEFINED]: {
    getDefaultValue: () => ({}),
    getLatestSchema: () => {
      throw Error('Not implemented');
    },
    Engine: () => {
      throw Error('Not implemented');
    },
    Entry: () => {
      throw Error('Not implemented');
    },
    Add: () => {
      throw Error('Not implemented');
    },
    yupSchemaEngine: () => {
      throw Error('Not implemented');
    },
    yupSchemaEntry: () => {
      throw Error('Not implemented');
    },
    translator: {},
    Placeholder: () => null,
    previewCardHeight: '120px'
  }
};

export default config;
